import { IStore } from '../index'

export const getDashboardVisitsCoverageValue = ({
  dashboardVisitsCoverageReducer,
}: IStore) => {
  return dashboardVisitsCoverageReducer
}
